import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PERSON_SOCIAL_METRICS } from "../keys";

const usePersonSocialMetrics = () => {
  const tenant = useSelector((state) => state.auth.tenant);

  return useQuery({
    queryKey: [PERSON_SOCIAL_METRICS, tenant.id],
    queryFn: ApiService.getPersonSocialMetrics,
    select: (data) => data.data,
    placeholderData: [{data: []}],
  });
};

export default usePersonSocialMetrics;
